<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">Configurações: Mercado Pago</h4>
      </div>
      <div>

        <fg-input
          name="Token"
          label="Token"
          v-model="model.payment_token"
        ></fg-input>
        <fg-input
          name="Aplicativo ID"
          label="Aplicativo ID"
          v-model="model.payment_id"
        ></fg-input>
        
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option } from "element-ui";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select
  },
  mounted() {
    const ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) {
      this.$store.dispatch("company/get", {id: ciaID}).then(data => {
        this.model = data
      });
    } else {
      this.$store.dispatch("company/get", {id: this.$store.state.auth.company}).then(data => {
        this.model = data
      });
    }
    this.crud = "Editar";
  },
  computed: {
    sales() {
      return this.$store.state.sales.sales;
    }
  },
  data() {
    return {
      crud: "Editar",
      featureFlag: [],
      model: {
        name: '',
        payment_methods: '',
        notification_url: ''

      },
      modelValidations: {
        name: {
          required: true
        }
      }
    };
  },
  methods: {
    localeDate(date) {
      const d = new Date(date);
      return d.toLocaleString("pt-BR");
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("company/create", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/companies`);
            });
        } else if (isValid && this.crud === "Editar") {
          console.log("customer", this.model);
          this.$store
            .dispatch("company/update", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/overview`);
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
